import {SwitchInput, TextInput} from 'components/forms/Inputs';
import React from 'react';
import {useRecordContext} from 'components/record/useRecordContext';
import {useController} from 'react-hook-form';

const ConfigurationForm = () => {
  const {record} = useRecordContext();
  const type = record.type;

  const {
    field: {onChange: onChangeValue}
  } = useController({name: 'value'});

  React.useEffect(() => {
    if (type === 'BOOLEAN') {
      onChangeValue(record.value === 'true');
    }
  }, [type, record.value, onChangeValue]);

  return (
    <React.Fragment>
      <TextInput required fullWidth label="Name" name="name" disabled />
      <TextInput fullWidth label="Description" name="description" disabled />
      <TextInput fullWidth label="Type" name="type" disabled />
      {type === 'BOOLEAN' && <SwitchInput label="Value" name="value" />}
      {(type === 'STRING' || type === 'INTEGER') && <TextInput fullWidth label="Value" name="value" />}
    </React.Fragment>
  );
};

export default ConfigurationForm;
